import Operator from "./Operator";


/*
    a           b               result
    0           0               true
    null        0               false
    0           null            false
    0           undefined       false
    undefined   0               false
    */

let Equal = Operator.extend("Equal", {
    literal: ["=", "equal", "=="],

    validateValue(value) {
        return this.validateLiteral(value);
    },

    compile2js(left, right) {
        // Доношу логику старых фильтров, на бэке фактически так и работает
        return `
            ${left} instanceof Array
                ? ${left}.some(value => value == ${JSON.stringify(right)})
                : ${left} == ${JSON.stringify(right)}
        `;
    }
});

export default Equal;
